module.exports = "<div class=\"container privacy-policy\">\r\n\r\n\t\t<div class=\"etiam\"  [innerHTML]=\"page_content[0]['value']\">\r\n\t\t\t\r\n\t</div>"